module.exports = __webpack_public_path__ + "img/03_full.29a67f1d.jpg";